import $api from "@http";

export default class DashboardService {
  static async getSessionsByMonth({fromDate, toDate, withArchived}) {
    return $api.post(
      `/api/v1/dashboard/sessions_by_month?with_archived=${withArchived}`,
      {
        start_date: fromDate,
        end_date: toDate,
      },
    );
  }

  static async getSessionsByScore({fromDate, toDate, withArchived}) {
    return $api.post(
      `/api/v1/dashboard/sessions_by_score?with_archived=${withArchived}`,
      {
        start_date: fromDate,
        end_date: toDate,
      },
    );
  }

  static async getSessionsByCountry({fromDate, toDate, withArchived}) {
    return $api.post(
      `/api/v1/dashboard/sessions_by_country?with_archived=${withArchived}`,
      {
        start_date: fromDate,
        end_date: toDate,
      },
    );
  }

  static async getUsersRanking({fromDate, toDate, withArchived, sort}) {
    const sortParam = sort
      ? `sort[${sort.value}]=${sort.direction}`
      : "sort[rank]=asc";

    return $api.post(
      `/api/v1/dashboard/user_ranking?${sortParam}&with_archived=${withArchived}`,
      {
        start_date: fromDate,
        end_date: toDate,
      },
    );
  }

  static async getLastActivity() {
    return $api.post("/api/v1/dashboard/last_activity");
  }

  static TYPE_TO_SCOPE = {
    certification: "certifications",
    manager: "managers",
    representative: "representatives",
    product_line: "product_lines",
  };

  static async getSearchType({type, name, limit, archived, signal}) {
    const scope = DashboardService.TYPE_TO_SCOPE[type] ?? type;
    const params = new URLSearchParams();
    if (name) params.append("query", name);
    if (limit != null) params.append("limit", limit);
    if (archived != null) params.append("archived", archived);
    return $api.get(`/api/v1/search/${scope}?${params.toString()}`, {signal});
  }

  static async getConfirmations({
    scenarioId,
    managerId,
    productLineId,
    fromDate,
    toDate,
    page,
    pageSize,
    withArchived,
    sort,
  }) {
    const params = new URLSearchParams();

    if (scenarioId) {
      params.append("scenario_id", scenarioId);
    }
    if (managerId) {
      params.append("manager_id", managerId);
    }
    if (productLineId) {
      params.append("product_line_id", productLineId);
    }
    if (fromDate) {
      params.append("start_date", fromDate);
    }
    if (toDate) {
      params.append("finish_date", toDate);
    }
    if (page) {
      params.append("page", page);
    }
    if (pageSize) {
      params.append("page_size", pageSize);
    }
    if (withArchived) {
      params.append("with_archived", withArchived);
    }

    if (sort) {
      params.append("sort", sort.value);
      params.append("sort_direction", sort.direction);
    }

    return $api.post(
      `/api/v1/certification_dashboard/last_activity?${params.toString()}`,
    );
  }

  static async getMarkersScore({
    scenario_id,
    manager_id,
    representative_id,
    product_line_id,
    start_date,
    finish_date,
    withArchived,
  }) {
    const params = new URLSearchParams();

    if (scenario_id) {
      params.append("scenario_id", scenario_id);
    }
    if (manager_id) {
      params.append("manager_id", manager_id);
    }
    if (representative_id) {
      params.append("representative_id", representative_id);
    }
    if (product_line_id) {
      params.append("product_line_id", product_line_id);
    }
    if (start_date) {
      params.append("start_date", start_date);
    }
    if (finish_date) {
      params.append("finish_date", finish_date);
    }
    if (withArchived) {
      params.append("with_archived", withArchived);
    }

    return $api.post(
      `/api/v1/certification_dashboard/feedback_allocations?${params.toString()}`,
    );
  }
}
